import { Http, Response, Headers, RequestOptions } from '@angular/http';

import {BaseHateoasApiService} from './base-hateoas-api-service';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { ParentBaseApiService } from './parent-base-api-service';
import { AbstractResource } from '../domain/abstract-resource';

export abstract class BaseApiService<T> extends ParentBaseApiService<T, T> {
}
